export const DASHBOARD_TYPES = ['dashboard', 'question', 'card', 'collection'];
